<app-breadcrumbs></app-breadcrumbs>

<h1>Search Products</h1>

<app-gallery-search-results></app-gallery-search-results>
